import { Component, OnInit } from '@angular/core';
import { TurnstileService } from './shared/services/turnstile.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'ncommerce-customer';

  constructor(private turnstile: TurnstileService) {}

  ngOnInit() {
    this.turnstile.warmup();
  }
}
